import { render, staticRenderFns } from "./rankmatchadd.vue?vue&type=template&id=512ed9eb&scoped=true"
import script from "./rankmatchadd.vue?vue&type=script&lang=js"
export * from "./rankmatchadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ed9eb",
  null
  
)

export default component.exports